import { ENV } from "@/constants/env";

// ----------------------------------------------------------------------------
// --- DEPRECATION NOTICE
// Please move this to each query file, this file will be removed in the future
// ----------------------------------------------------------------------------
export const callServiceEndpoints = {
    subscribe: `${ENV.CALL_SVC_URL}/voice/subscribe`,

    // Phone Numbers
    getPhoneNumbers: `${ENV.CALL_SVC_URL}/phone-numbers`,
    getMyPhoneNumbers: `${ENV.CALL_SVC_URL}/phone-numbers/me`,
    getPhoneNumbersByUserId: (userId: string) => `${ENV.CALL_SVC_URL}/phone-numbers/users/${userId}`,
    getPhoneNumberUsers: (id: string) => `${ENV.CALL_SVC_URL}/phone-numbers/${id}/users`,
    getAvailablePhoneNumbers: `${ENV.CALL_SVC_URL}/phone-numbers/available`,
    createPhoneNumber: `${ENV.CALL_SVC_URL}/phone-numbers`,
    updatePhoneNumber: (id: string) => `${ENV.CALL_SVC_URL}/phone-numbers/${id}`,
    deletePhoneNumber: (id: string) => `${ENV.CALL_SVC_URL}/phone-numbers/${id}`,
    assignPhoneNumberAccess: `${ENV.CALL_SVC_URL}/phone-numbers-access`,
    unassignPhoneNumberAccess: `${ENV.CALL_SVC_URL}/phone-numbers-access`,

    // Calls
    getCall: (id: string) => `${ENV.CALL_SVC_URL}/calls/${id}`,
    getCallsByUser: `${ENV.CALL_SVC_URL}/calls`,
    createCall: `${ENV.CALL_SVC_URL}/calls`,
    updateCall: (id: string) => `${ENV.CALL_SVC_URL}/calls/${id}`,
    getCallsForQualityWatchChart: `${ENV.CALL_SVC_URL}/calls/quality-watch`,

    // KPIs
    getKpiByDate: (date: string) => `${ENV.CALL_SVC_URL}/calls/kpis/${date}`,
    getKpiByDateRange: `${ENV.CALL_SVC_URL}/calls/kpis/`,
    getTeamMembersKpiByDate: (date: string) => `${ENV.CALL_SVC_URL}/calls/kpis/team/${date}`,
    getTeamMembersKpiByDateRange: `${ENV.CALL_SVC_URL}/calls/kpis/team/`,
    getUserKpiByDate: (date: string) => `${ENV.CALL_SVC_URL}/calls/kpis/${date}`,

    // Leads
    getLeadById: (id: string) => `${ENV.CALL_SVC_URL}/lead/zoho/${id}`,
    getLeadStatuses: `${ENV.CALL_SVC_URL}/lead/statuses`,
    getAndAssignLeads: `${ENV.CALL_SVC_URL}/lead/assign`,
    unassignLeads: `${ENV.CALL_SVC_URL}/lead/unassign`,
    adminUnassignLeads: (userId: string) => `${ENV.CALL_SVC_URL}/lead/admin/unassign/${userId}`,
    unassignLead: (id: string) => `${ENV.CALL_SVC_URL}/lead/unassign/${id}`,
    resolveLead: (id: string) => `${ENV.CALL_SVC_URL}/lead/resolve/${id}`,
    leadAction: (zohoLeadId: string) => `${ENV.CALL_SVC_URL}/lead/action/${zohoLeadId}`,
    hideLead: (id: string) => `${ENV.CALL_SVC_URL}/lead/hide/${id}`,
    deleteLead: (brandName: string, zohoLeadId: string) =>
        `${ENV.CALL_SVC_URL}/lead/${brandName}?zohoLeadId=${encodeURIComponent(zohoLeadId)}`,
    searchLeadsByPhone: `${ENV.CALL_SVC_URL}/lead/search`,

    // Contacts
    getContactById: (id: string) => `${ENV.CALL_SVC_URL}/contact/${id}`,

    // Telli
    getTelliContacts: `${ENV.CALL_SVC_URL}/telli/contacts`,
    getTelliContactByExternalId: (externalId: string) =>
        `${ENV.CALL_SVC_URL}/telli/contacts/external/${encodeURIComponent(externalId)}`,
    createTelliContact: `${ENV.CALL_SVC_URL}/telli/contacts`,
    getTelliAgents: `${ENV.CALL_SVC_URL}/telli/agents`,
    getTelliCalls: `${ENV.CALL_SVC_URL}/telli/calls`,
    getTelliCall: (callId: string) => `${ENV.CALL_SVC_URL}/telli/calls/${encodeURIComponent(callId)}`,
    initiateTelliCall: `${ENV.CALL_SVC_URL}/telli/calls/initiate`,
    getTelliWorkerStatus: `${ENV.CALL_SVC_URL}/telli/worker/status`,
    startTelliWorker: `${ENV.CALL_SVC_URL}/telli/worker/start`,
    stopTelliWorker: `${ENV.CALL_SVC_URL}/telli/worker/stop`,

    /** Resolve CRM lead or contact by email (full records). */
    getPersonByEmail: (email: string) => `${ENV.CALL_SVC_URL}/crm/people/email/${encodeURIComponent(email)}`,

    // Agent Seat Assignments
    getAgentSeatAssignments: `${ENV.CALL_SVC_URL}/agent-seat-assignments`,
    createAgentSeatAssignment: `${ENV.CALL_SVC_URL}/agent-seat-assignments`,
    updateAgentSeatAssignment: (tableId: string, seatNumber: number) =>
        `${ENV.CALL_SVC_URL}/agent-seat-assignments/${tableId}/${seatNumber}`,
    deleteAgentSeatAssignment: (tableId: string, seatNumber: number) =>
        `${ENV.CALL_SVC_URL}/agent-seat-assignments/${tableId}/${seatNumber}`,
};

export const calendarServiceEndpoints = {
    /** Live snapshot: booked/max per calendar for today & tomorrow (Redis-backed). */
    getCalendarCapacities: `${ENV.CALL_SVC_URL}/calendar/capacities`,

    // Event types
    getAllEventTypes: `${ENV.CALL_SVC_URL}/calendar/event-types`,
    createEventType: `${ENV.CALL_SVC_URL}/calendar/event-types`,
    getEventType: (id: string) => `${ENV.CALL_SVC_URL}/calendar/event-types/${id}`,
    updateEventType: (id: string) => `${ENV.CALL_SVC_URL}/calendar/event-types/${id}`,
    deleteEventType: (id: string) => `${ENV.CALL_SVC_URL}/calendar/event-types/${id}`,
    getEventTypeRules: (id: string) => `${ENV.CALL_SVC_URL}/calendar/event-types/${id}/rules`,
    addEventTypeRule: (id: string) => `${ENV.CALL_SVC_URL}/calendar/event-types/${id}/rules`,
    updateEventTypeRule: (id: string, ruleId: string) =>
        `${ENV.CALL_SVC_URL}/calendar/event-types/${id}/rules/${ruleId}`,
    removeEventTypeRule: (id: string, ruleId: string) =>
        `${ENV.CALL_SVC_URL}/calendar/event-types/${id}/rules/${ruleId}`,

    // Bookable slots (computed from rules + host schedules)
    getEventTypeSlots: `${ENV.CALL_SVC_URL}/calendar/slots`,
    getEventTypeSlotsById: (id: string) => `${ENV.CALL_SVC_URL}/calendar/slots/public/event-type/${id}`,
    regenerateEventTypeSlots: (id: string) => `${ENV.CALL_SVC_URL}/calendar/slots/event-type/${id}`,

    // Bookings
    getBookings: `${ENV.CALL_SVC_URL}/calendar/bookings`,
    createBooking: `${ENV.CALL_SVC_URL}/calendar/bookings`,
    getMyBookings: `${ENV.CALL_SVC_URL}/calendar/bookings/me`,
    updateBooking: (id: string) => `${ENV.CALL_SVC_URL}/calendar/bookings/${id}`,
    cancelBooking: (id: string) => `${ENV.CALL_SVC_URL}/calendar/bookings/${id}`,

    // Calendars (legacy – appointments)
    getAllCalendars: `${ENV.CALL_SVC_URL}/calendars`,
    createCalendar: `${ENV.CALL_SVC_URL}/calendars`,
    updateCalendar: (id: string) => `${ENV.CALL_SVC_URL}/calendars/${id}`,
    deleteCalendar: (id: string) => `${ENV.CALL_SVC_URL}/calendars/${id}`,

    // Plans (legacy)
    getCalendarTimePlans: (calendarId: string) => `${ENV.CALL_SVC_URL}/calendars/${calendarId}/plans`,
    createCalendarTimePlan: (calendarId: string) => `${ENV.CALL_SVC_URL}/calendars/${calendarId}/plans`,
    updateCalendarTimePlan: (calendarId: string, planId: string) =>
        `${ENV.CALL_SVC_URL}/calendars/${calendarId}/plans/${planId}`,
    deleteCalendarTimePlan: (calendarId: string, planId: string) =>
        `${ENV.CALL_SVC_URL}/calendars/${calendarId}/plans/${planId}`,

    // APPOINTMENTS
    getPendingAppointments: `${ENV.CALL_SVC_URL}/calendars/appointments/pending`,
    getAppointmentsByCalendar: (calendarName: string) => `${ENV.CALL_SVC_URL}/calendars/appointments/${calendarName}`,
    markAppointmentPending: (id: string) => `${ENV.CALL_SVC_URL}/calendars/appointments/markPending/${id}`,
    deletePendingAppointment: (id: string) => `${ENV.CALL_SVC_URL}/calendars/appointments/deletePending/${id}`,
    updateAppointmentStatus: (id: string) => `${ENV.CALL_SVC_URL}/calendars/appointments/${id}/status`,
};

export const transcriptServiceEndpoints = {
    getTranscriptsByCallId: (callId: string) => `${ENV.CALL_SVC_URL}/transcripts/call/${callId}`,
    deleteTranscript: (id: string) => `${ENV.CALL_SVC_URL}/transcripts/${id}`,
    sendTranscriptToWebhook: (id: string) => `${ENV.CALL_SVC_URL}/transcripts/${id}/webhook`,
    enqueuePendingGenerationCall: `${ENV.CALL_SVC_URL}/transcripts/pending-generation-call`,
};

export const authServiceEndpoints = {
    getUsers: `${ENV.AUTH_SVC_URL}/user/list`,
    getUserById: (id: string) => `${ENV.AUTH_SVC_URL}/user/find/id/${id}`,
    getUsersByIds: `${ENV.AUTH_SVC_URL}/user/batch`,
    getMe: `${ENV.AUTH_SVC_URL}/user/me`,
    getUserByEmail: (email: string) => `${ENV.AUTH_SVC_URL}/user/find/email/${email}`,
    refreshToken: `${ENV.AUTH_SVC_URL}/auth/token`,
    logout: `${ENV.AUTH_SVC_URL}/auth/logout`,
};

export const teamServiceEndpoints = {
    getTeams: `${ENV.CALL_SVC_URL}/team`,
    getTeamById: (id: string) => `${ENV.CALL_SVC_URL}/team/${id}`,
    createTeam: `${ENV.CALL_SVC_URL}/team`,
    updateTeam: (id: string) => `${ENV.CALL_SVC_URL}/team/${id}`,
    deleteTeam: (id: string) => `${ENV.CALL_SVC_URL}/team/${id}`,
};

export const dimensionDefinitionEndpoints = {
    getAll: `${ENV.CALL_SVC_URL}/dimensions/definitions`,
    getById: (id: string) => `${ENV.CALL_SVC_URL}/dimensions/definitions/${id}`,
    create: `${ENV.CALL_SVC_URL}/dimensions/definitions`,
    update: (id: string) => `${ENV.CALL_SVC_URL}/dimensions/definitions/${id}`,
    delete: (id: string) => `${ENV.CALL_SVC_URL}/dimensions/definitions/${id}`,

    getUserAverageDimension: `${ENV.CALL_SVC_URL}/user-avg-dimension-view`,
};

export const scheduleServiceEndpoints = {
    getAll: `${ENV.CALL_SVC_URL}/calendar/schedules`,
    getById: (id: string) => `${ENV.CALL_SVC_URL}/calendar/schedules/${id}`,
    getByUserId: (userId: string) => `${ENV.CALL_SVC_URL}/calendar/schedules/users/${userId}`,
    create: `${ENV.CALL_SVC_URL}/calendar/schedules`,
    update: (id: string) => `${ENV.CALL_SVC_URL}/calendar/schedules/${id}`,
    delete: (id: string) => `${ENV.CALL_SVC_URL}/calendar/schedules/${id}`,
    addExceptionDates: (id: string) => `${ENV.CALL_SVC_URL}/calendar/schedules/${id}/exception-dates`,
    overrideExceptionDateByDate: (id: string, date: string) =>
        `${ENV.CALL_SVC_URL}/calendar/schedules/${id}/exception-dates/${date}`,
    deleteExceptionDateByDate: (id: string, date: string) =>
        `${ENV.CALL_SVC_URL}/calendar/schedules/${id}/exception-dates/${date}`,
};

export const incidentEndpoints = {
    createIncident: `${ENV.CALL_SVC_URL}/incident-reports`,
    getIncidents: `${ENV.CALL_SVC_URL}/incident-reports`,
    getIncidentAnalytics: `${ENV.CALL_SVC_URL}/incident-reports/analytics`,
    updateIncident: (id: string) => `${ENV.CALL_SVC_URL}/incident-reports/${id}`,
    removeReviewer: (id: string, reviewerId: string) =>
        `${ENV.CALL_SVC_URL}/incident-reports/${id}/reviewers/${reviewerId}`,
    getNotes: (id: string) => `${ENV.CALL_SVC_URL}/incident-reports/${id}/notes`,
    createNote: (id: string) => `${ENV.CALL_SVC_URL}/incident-reports/${id}/notes`,
};

export const chatbotEndpoints = {
    health: `${ENV.CALL_SVC_URL}/chatbot/health`,
    chat: `${ENV.CALL_SVC_URL}/chatbot/chat`,
    chatStream: `${ENV.CALL_SVC_URL}/chatbot/chat/stream`,
    clearHistory: `${ENV.CALL_SVC_URL}/chatbot/chat/clear`,
};
